import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Permite que o navegador envie cookies (como o de CSRF) em requisições cross-origin.
});
let refreshRequest = null;

// Função para obter o valor de um cookie pelo nome. O Django envia o cookie 'csrftoken'.
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // O cookie começa com o nome que queremos?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // Anexa o token CSRF em requisições que alteram dados (POST, PUT, DELETE, etc.)
  if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(config.method.toUpperCase())) {
    config.headers['X-CSRFToken'] = getCookie('csrftoken');
  }
  return config;
}, (error) => Promise.reject(error));

axiosInstance.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;

  if (error.response?.status === 401 && !originalRequest._retry && originalRequest.url !== '/api/token/' && originalRequest.url !== '/api/token/refresh/') {
    originalRequest._retry = true;
    const currentAccessToken = localStorage.getItem('accessToken');
    const requestAuthorization = originalRequest.headers?.get?.('Authorization')
      || originalRequest.headers?.Authorization;

    // Outra requisição pode ter renovado o token enquanto esta resposta 401 chegava.
    if (currentAccessToken && requestAuthorization !== `Bearer ${currentAccessToken}`) {
      originalRequest.headers['Authorization'] = `Bearer ${currentAccessToken}`;
      return axiosInstance(originalRequest);
    }

    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try {
        if (!refreshRequest) {
          refreshRequest = axios.post(`${API_URL}/api/token/refresh/`, { refresh: refreshToken })
            .then((response) => {
              localStorage.setItem('accessToken', response.data.access);
              if (response.data.refresh) {
                localStorage.setItem('refreshToken', response.data.refresh);
              }
              axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
              return response.data.access;
            })
            .finally(() => {
              refreshRequest = null;
            });
        }

        const accessToken = await refreshRequest;
        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = '/'; // Redireciona se o refresh token falhar
        return Promise.reject(refreshError);
      }
    } else {
      localStorage.clear();
      window.location.href = '/'; // Redireciona se não houver refresh token
    }
  }

  return Promise.reject(error);
});

axiosInstance.put = (url, data, config) => axiosInstance({ method: 'put', url, data, ...config });

export default axiosInstance;
